// extracted by mini-css-extract-plugin
export var aboveInput = "_ma-0";
export var actionButton = "_ma-5";
export var actionButtonContainer = "_ma-1";
export var actionIcon = "_ma-6";
export var aiInfoContainer = "_ma-2";
export var attachmentWrapper = "_ma-7";
export var bold = "_ma-3";
export var checkIcon = "_ma-8";
export var clickingRecipientBar = "_ma-11";
export var commentThreadSwitch = "_ma-a";
export var draftImage = "_ma-b";
export var draftImageContainer = "_ma-c";
export var draftImages = "_ma-e";
export var editButton = "_ma-g";
export var editor = "_ma-f";
export var editorContainer = "_ma-y";
export var editorErrorTooltipWrapper = "_ma-9";
export var headerDivider = "_ma-h";
export var icon = "_ma-i";
export var info = "_ma-j";
export var internal = "_ma-n";
export var internalDivider = "_ma-k";
export var internalMessage = "_ma-l";
export var messageInputCard = "_ma-m";
export var messageInputForm = "_ma-o";
export var messageInputFormInternal = "_ma-p";
export var options = "_ma-q";
export var publicMessageCustomer = "_ma-s";
export var publicMessageMerchant = "_ma-r";
export var removeImageButton = "_ma-d";
export var replyButtons = "_ma-t";
export var showSignatureButton = "_ma-u";
export var spinner = "_ma-v";
export var verticalButtonDivider = "_ma-4";
export var visibilitySelector = "_ma-w";
export var warning = "_ma-x";
export var wrappingText = "_ma-z";
export var writingInternalNoteTopBorder = "_ma-10";